/* jshint esversion: 6 */
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { MyContext } from "../../Context/MyProvider";

export default function PharmacyTrack() {
  const { order_reference } = useParams();
  const { ApiBaseUrl } = useContext(MyContext);
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const uid = secureLocalStorage.getItem("Userid") || "0";
    axios.get(`${ApiBaseUrl}/api/v1/pharmacy/orders/${order_reference}?id=${uid}`)
      .then((res) => { if (res.data.success) setOrder(res.data.order); });
  }, [ApiBaseUrl, order_reference]);

  if (!order) return <div className="width-container py-8">Loading…</div>;

  return (
    <div className="width-container py-8">
      <h1 className="text-2xl font-bold mb-2">Order {order.order_reference}</h1>
      <p className="text-rm-primary font-medium">Fulfilled by {order.pharmacy_assigned}</p>
      <p className="mb-4">Status: <strong>{order.status}</strong> · ETA ~{order.delivery?.estimated_time_min} min</p>
      <p className="text-sm text-gray-600 mb-4">{order.delivery?.address}</p>
      <h3 className="font-semibold mb-2">Timeline</h3>
      <ul className="space-y-2">
        {(order.status_timeline || []).map((s, i) => (
          <li key={i} className="text-sm">{s.status} — {new Date(s.timestamp).toLocaleString()}</li>
        ))}
      </ul>
      {order.next_actions?.length > 0 && (
        <div className="mt-6 p-4 bg-teal-50 rounded-lg">
          <p className="font-medium">{order.next_actions[0].action}</p>
        </div>
      )}
    </div>
  );
}
